import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text,
} from 'ol/style';

import { getSideStyle } from '#nora-ui/map/drawtools/styles/tactical-annotation-style';

export function routeStyleFunction(): Style[] {
  const lineColor = '#00FBFD';
  return getRouteLineStyle(lineColor);
}

export function getRouteLineStyle(color: string): Style[] {
  return getSideStyle(color);
}

export function getRoutePointStyle(
  text: string,
  state: 'default' | 'hover' | 'highlighted' = 'default',
): Style[] {
  let fillColor = '#00FBFD';

  if (state === 'hover') {
    fillColor = '#00D6D8';
  }
  else if (state === 'highlighted') {
    fillColor = '#0088ff';
  }

  return [
    new Style({
      image: new CircleStyle({
        radius: 12,
        fill: new Fill({ color: fillColor }),
        stroke: new Stroke({
          color: '#000000',
          width: 2,
        }),
      }),
      text: new Text({
        text,
        font: 'bold 16px Source Sans Pro',
        fill: new Fill({ color: 'black' }),
        offsetY: 0,
      }),
      zIndex: 3,
    }),
  ];
}
